import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 6.21582L0.303845 0.965824L10.6962 0.965821L5.5 6.21582Z", fill: "currentColor" }));
export default SvgArrow;
